/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateReview200ResponseAllOfData } from './CreateReview200ResponseAllOfData';
import {
    CreateReview200ResponseAllOfDataFromJSON,
    CreateReview200ResponseAllOfDataFromJSONTyped,
    CreateReview200ResponseAllOfDataToJSON,
} from './CreateReview200ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateReview200ResponseAllOf
 */
export interface CreateReview200ResponseAllOf {
    /**
     * 
     * @type {CreateReview200ResponseAllOfData}
     * @memberof CreateReview200ResponseAllOf
     */
    data: CreateReview200ResponseAllOfData;
}

/**
 * Check if a given object implements the CreateReview200ResponseAllOf interface.
 */
export function instanceOfCreateReview200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function CreateReview200ResponseAllOfFromJSON(json: any): CreateReview200ResponseAllOf {
    return CreateReview200ResponseAllOfFromJSONTyped(json, false);
}

export function CreateReview200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReview200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateReview200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function CreateReview200ResponseAllOfToJSON(value?: CreateReview200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateReview200ResponseAllOfDataToJSON(value.data),
    };
}

